<!-- 跳转页面 test-local-to -->
<template>
  <div></div>
</template>
<script>
export default{
  created() {
    this.getLocalData()
  },
  methods: {
    getLocalData() {
      // session 获取session
      let code = sessionStorage.code
      console.log('code =', code)
      let page = sessionStorage.getItem('page')
      console.log('page =', page)
      // local 获取local
      let age = localStorage.age
      console.log('age =', age)
      let passcode = localStorage.getItem('passcode')
      console.log('passcode =', passcode)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/A.vue